import {graphql} from 'gatsby'
import React from 'react'

import type {
    SocialProofSliceFragment,
    PartnerTemplateSocialProofFragment,
    SocialProofFragment,
} from '@/graphql-types'
import QuoteCarousel from '@/sections/quote-carousel'

type Props = {
    slice: SocialProofSliceFragment | SocialProofFragment | PartnerTemplateSocialProofFragment

    dataTestId?: string
}

export const SocialProofSlice = React.forwardRef(({slice, dataTestId}: Props, ref) => {
    const items = slice.items.map((proof) => ({
        image: proof.predefined_testimonial.document?.data.image ?? proof.image,
        quote: proof.predefined_testimonial.document?.data.quote ?? proof.quote,
        mirrored: slice.primary.inverse,
        attribution: {
            name: proof.predefined_testimonial.document?.data.attribution_name ?? proof.full_name,
            title:
                proof.predefined_testimonial.document?.data.attribution_title ??
                proof.person_byline,
        },
    }))
    return (
        <QuoteCarousel
            ref={ref}
            title={slice.primary.title}
            items={items}
            dataTestId={dataTestId}
        />
    )
})

export const socialProofSliceFragment = graphql`
    fragment SocialProofSlice on PrismicSlicePageDataBodySocialProof {
        __typename
        primary {
            title
            inverse
        }
        items {
            image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
                gatsbyImageData(breakpoints: $imageBreakpoints, sizes: $twoColumnsAsymmetric)
            }
            quote
            full_name
            person_byline
            predefined_testimonial {
                document {
                    ... on PrismicTestimonial {
                        data {
                            image {
                                alt
                                copyright
                                url
                                dimensions {
                                    height
                                    width
                                }
                                gatsbyImageData(
                                    breakpoints: $imageBreakpoints
                                    sizes: $twoColumnsAsymmetric
                                )
                            }
                            quote
                            attribution_name
                            attribution_title
                        }
                    }
                }
            }
        }
    }
`
